import type { AbsenceRequest } from "@/lib/absence-tracking-api"

import { Badge } from "@/components/ui/badge"

import { type SemanticTone } from "./tone-styles"

const displayByState: Record<AbsenceRequest["state"], string> = {
  approved: "Active",
  pending: "Pending",
  rejected: "Noted",
  cancelled: "Cancelled",
}

const toneMap: Record<AbsenceRequest["state"], SemanticTone> = {
  approved: "success",
  pending: "warning",
  rejected: "danger",
  cancelled: "muted",
}

export function AbsenceStateBadge({
  state,
}: {
  state: AbsenceRequest["state"]
}) {
  const toneClass = (() => {
    switch (toneMap[state]) {
      case "success":
        return "border-success/40 bg-success/15 text-success"
      case "warning":
        return "border-warning/40 bg-warning/15 text-warning"
      case "danger":
        return "border-danger/40 bg-danger/15 text-danger"
      case "muted":
        return "border-border bg-muted/60 text-muted-foreground"
    }
  })()

  return (
    <Badge
      variant="outline"
      className={`rounded-full px-2.5 py-1 text-xs font-semibold ${toneClass}`}
    >
      {displayByState[state]}
    </Badge>
  )
}
